import { Navigate, useLocation } from "react-router-dom";
import { Loader2 } from "lucide-react";

import { useAuth } from "@/context/AuthContext";
import { APP } from "@/constants/testIds";

const FullScreenLoader = () => (
  <div className="grid min-h-screen place-items-center bg-secondary/40" data-testid={APP.protectedLoading}>
    <div className="flex flex-col items-center gap-3 text-muted-foreground">
      <Loader2 className="h-6 w-6 animate-spin text-accent" />
      <span className="text-sm">Loading your workspace…</span>
    </div>
  </div>
);

/**
 * Guards protected application routes. Unauthenticated users are redirected to
 * /login (server-side authorization is still the real enforcement). An optional
 * requiredPermission gates admin/other routes at the UI layer.
 */
export const ProtectedRoute = ({ children, requiredPermission }) => {
  const { status, hasPermission } = useAuth();
  const location = useLocation();

  if (status === "loading") return <FullScreenLoader />;
  if (status === "unauthenticated") {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }
  if (requiredPermission && !hasPermission(requiredPermission)) {
    return <Navigate to="/" replace />;
  }
  return children;
};

/** Redirects already-authenticated users away from public auth pages. */
export const PublicOnlyRoute = ({ children }) => {
  const { status } = useAuth();
  if (status === "loading") return <FullScreenLoader />;
  if (status === "authenticated") return <Navigate to="/" replace />;
  return children;
};
